module.exports = __webpack_public_path__ + "static/media/anc8ru.2b056c76.pdf";